<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">


          <div class="card-header card-header-danger">
            <div class="row">
              <div class="col-md-6">
                <h4 id="lblheader">{{lblheader}} </h4>
              </div>
              <div class="col-md-6" style="text-align: right;">
                <i class="fas fa-filter" style="font-size:14px; cursor: pointer" (click)="Filter.click()">
                  <button type="button" #Filter style="display:none;" (click)="openSearchDialog()"></button>

                </i>
                &nbsp;&nbsp;


                <button type="button" class="btn-primary1" (click)="Export()">Export</button>

                <button type="button" class="btn-primary1" (click)="_commonService.Exit()">Exit</button>

              </div>
            </div>


          </div>
          <div class="card-body" style="overflow: scroll;">
            <div class="row">
              <div class="col-md-4" style="display: -webkit-inline-box;">


                <input type="text" placeholder="SR Number" class="form-control" [(ngModel)]="selectedSR" />
                &nbsp;&nbsp;
                <!-- <p-autoComplete [(ngModel)]="selectedSR"
                    [suggestions]="SRNumberList"
                    (completeMethod)="filterSR($event)" 
                    field="Value" 
                    [forceSelection]="true"
                    [minLength]="3" 
                    size="120" 
                    emptyMessage="No Record Found"
                    (onClear)="clearAutoComplete($event)" 
                    >
                  </p-autoComplete> -->
                <button type="button" class="btn-primary1" (click)="SearchSR()">Search</button>

              </div>
            </div>
            <br>
            <div class="tabel-loading-shade" *ngIf="isLoadingResults">
              <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
            </div>
            <div class="table-container" style="width: 100%;">
              <table mat-table [dataSource]="SRDataSource" matSort>
                <!-- Position Column -->
                <ng-container matColumnDef="SRNumber">
                  <th mat-header-cell *matHeaderCellDef class="table-column-100" mat-sort-header> Number </th>
                  <td mat-cell *matCellDef="let element" class="table-column-100">
                    <a style="color: blue;"> <span style="display:none">{{element.RequestEntityId}}</span>
                      {{element.SRNumber}}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="CreatedOn">
                  <th mat-header-cell *matHeaderCellDef class="table-column-100" mat-sort-header> Created On </th>
                  <td mat-cell *matCellDef="let element" class="table-column-100" (click)="$event.stopPropagation()">
                    {{element.CreatedOn | date:'dd/MMM/yyyy'}} </td>
                </ng-container>
                <!-- Name Column -->


                <!-- Weight Column -->
                <ng-container matColumnDef="LongDescription">
                  <th mat-header-cell *matHeaderCellDef class="table-column-100" mat-sort-header> Description</th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" class="table-column-100">
                    {{element.LongDescription}}
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Requester">
                  <th mat-header-cell *matHeaderCellDef class="table-column-100" mat-sort-header> Requester </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" class="table-column-100">
                    {{element.RequestedBy}} </td>
                </ng-container>

                <ng-container matColumnDef="OnBehalfOfRequester">
                  <th mat-header-cell *matHeaderCellDef class="table-column-100" mat-sort-header> (On behalf of)
                    Requester </th>
                  <td mat-cell *matCellDef="let element" class="table-column-100" (click)="$event.stopPropagation()">
                    {{element.RequestedFor}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="ShortDescription">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Short Description </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                    {{element.ShortDescription}} </td>
                </ng-container>

                <ng-container matColumnDef="RequesterGPN">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Requester GPN </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.RequestedByGPN}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="AssignmentGroup">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Assignment Group</th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.AssignmentGroup}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="TicketStatus">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Status </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.StatusName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="AssignedTo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Assigned To </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.AssignedToName}}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                  (click)="ShowDetails(row)"></tr>
              </table>
            </div>

            <mat-paginator #paginator [pageSize]="this._global.RecordSize" [pageSizeOptions]="[5, 10, 20]"
              [showFirstLastButtons]="true" [length]="_global.length" [pageIndex]=" this._global.pageIndex"
              (page)="onPaginateChange($event)" [length]="_global.length"></mat-paginator>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>